import React, { useState, useEffect } from 'react';
import './PWAInstallPrompt.css';

const PWAInstallPrompt = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the default prompt
      e.preventDefault();
      // Store the event for later use
      setDeferredPrompt(e);

      // Show the install prompt after 5 seconds
      setTimeout(() => {
        setShowPrompt(true);
      }, 5000);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;

    console.log(`User response to the install prompt: ${outcome}`);

    // Clear the deferredPrompt
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    // Store in localStorage to not show again for 7 days
    localStorage.setItem('pwa-install-dismissed', Date.now());
  };

  // Check if user dismissed it recently (within 7 days)
  useEffect(() => {
    const dismissedTime = localStorage.getItem('pwa-install-dismissed');
    if (dismissedTime) {
      const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
      const timePassed = Date.now() - parseInt(dismissedTime);
      if (timePassed < sevenDaysInMs) {
        setShowPrompt(false);
      }
    }
  }, []);

  if (!showPrompt || !deferredPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-prompt-overlay">
      <div className="pwa-install-prompt">
        <button
          className="pwa-install-prompt-close"
          onClick={handleDismiss}
          aria-label="Close"
        >
          ×
        </button>

        <div className="pwa-install-prompt-icon">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
              fill="currentColor"
            />
          </svg>
        </div>

        <h3 className="pwa-install-prompt-title">Install This App</h3>
        <p className="pwa-install-prompt-description">
          Install Indian Festival Calendar on your device for quick and easy access!
        </p>

        <div className="pwa-install-prompt-benefits">
          <div className="pwa-install-benefit">
            <span className="pwa-install-benefit-icon">⚡</span>
            <span>Faster loading</span>
          </div>
          <div className="pwa-install-benefit">
            <span className="pwa-install-benefit-icon">📱</span>
            <span>Works offline</span>
          </div>
          <div className="pwa-install-benefit">
            <span className="pwa-install-benefit-icon">🏠</span>
            <span>Home screen access</span>
          </div>
        </div>

        <div className="pwa-install-prompt-actions">
          <button
            className="pwa-install-prompt-btn pwa-install-btn-primary"
            onClick={handleInstallClick}
          >
            Install App
          </button>
          <button
            className="pwa-install-prompt-btn pwa-install-btn-secondary"
            onClick={handleDismiss}
          >
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
